const values = {
    BOARD_TYPE: 'NoticeBoard',
    BOARD_NAME: '자주하는질문',
    PAGE_SIZE: 10,
};

export default values;
